import 'what-input'
import React, { ReactNode, useEffect } from 'react'
import { animateScroll } from 'react-scroll'
import { css } from 'linaria'
import { useLocation } from '@reach/router'
import Breadcrumb, { BreadcrumbTypes } from '~/components/Common/Breadcrumb'
import Header from '~/components/Common/Header'
import HeaderBackgroundcheck from '~/components/Backgroundcheck/Header'
import Footer from '~/components/Common/Footer'
import Seo, { SeoTypes } from '~/components/Common/Seo'
import { STYLE } from '~/utils/constant'

interface LayoutProps {
  children: ReactNode
  breadcrumb?: BreadcrumbTypes[]
  seo?: SeoTypes
}

const wrapper = css`
  display: flex;
  flex-direction: column;
  min-height: 100dvh;

  & > .main-content {
    flex-grow: 1;
    order: 1;

    @media screen and (${STYLE.MEDIA.TABLET}) {
      order: 0;
    }
  }
`

const LayoutComponent = ({ breadcrumb, children, seo }: LayoutProps) => {
  const { pathname, hash } = useLocation()
  const isBackgroundcheckPage = pathname.startsWith('/backgroundcheck')

  useEffect(() => {
    // Note: URLにhashが含まれていた際、該当箇所までスムーススクロールさせる
    if (hash) {
      // Note: 先頭の#をトルツメ
      const target = document.getElementById(hash.replace(/^#/, ''))
      if (target) {
        // Note: アニメーションのために1度最上部へスクロール
        window.scrollTo(0, 0)
        // Note: offsetがうまく動作しないため実数を指定
        animateScroll.scrollTo(target.offsetTop - 108, {
          smooth: true,
          duration: 240,
          delay: 10,
        })
      }
    }
  }, [pathname])

  return (
    <div id="top" className={wrapper}>
      <Seo seo={seo} />
      {!isBackgroundcheckPage ? <Header /> : <HeaderBackgroundcheck />}
      {/* Note: breadcrumbがundefinedのときは描画しない */}
      {breadcrumb && <Breadcrumb breadcrumb={breadcrumb} />}
      <div className="main-content">{children}</div>
      <Footer />
    </div>
  )
}

export default LayoutComponent
